import { APIClient } from "api/api_helper";
import { VACUTAINER_LABEL_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

export const VacutainerLabelApiService = {
    // SELECT ALL by studyid 
    selectAll: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        let period_number: string | null = null;
        if (payload_data.period && payload_data.period !== "ALL") {
            period_number = String(payload_data.period);
        }

        let timepoint_number: string[] | null = null;
        if (payload_data.timepoint) {
            if (Array.isArray(payload_data.timepoint)) {
                const validTps = payload_data.timepoint.filter((tp: any) => tp !== "ALL");
                if (validTps.length > 0) {
                    timepoint_number = validTps.map((tp: any) => String(tp).trim());
                } else {
                    timepoint_number = null;
                }
            } else if (payload_data.timepoint !== "ALL") {
                timepoint_number = [String(payload_data.timepoint).trim()];
            }
        }

        const payload = {
            studyid: payload_data.studyid,
            period_number: period_number,
            timepoint_number: timepoint_number,
            currentpage: payload_data.currentpage ?? null,
            pagesize: payload_data.pagesize ?? null,
            searchtext: payload_data.searchtext || "",
        };
        return api.create(VACUTAINER_LABEL_API.VACUTAINER_LABEL_API + "SelectAll", payload);
    },

    // UPDATE print status after printing
    updateVacutainerLabel: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            studyid: payload_data.studyid,
            samplecollection: payload_data.samplecollection || [],
            printby: user?.userid,
        };
        return api.create(VACUTAINER_LABEL_API.VACUTAINER_LABEL_API + "Update", payload);
    },

    // INSERT REPRINT HISTORY METHOD
    insertVacutainerLabelhistory: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            studyid: payload_data.studyid,
            printby: user?.userid,
            verifiedby: null,
            reasonforreprint: payload_data.reasonforreprint ? parseInt(payload_data.reasonforreprint, 10) : null,
            additionalcomments: payload_data.additionalcomments || null,
            printcount: payload_data.printcount || 1,
            jsondata: payload_data.jsondata || [],
        };
        return api.create(sessionStorage.getItem("baseUrl") + "VacutainerHistory/Insert", payload);
    },
}